import { GroupActivityPane } from '@/components/GroupPage/GroupActivityPane';
import { RouteRestrictions } from '@/utilities';
import { restrictedRoute } from '@/utilities/restrictedRoute';

export default restrictedRoute(GroupActivityPane, {
  requiresEvery: [RouteRestrictions.COMMUNITY_ACCESS],
});
